// @flow
/**
 * Extra information attached to a navigation.
 * @constructor
 */
class NavigateData {
  evt: ?Object;
  handled: boolean;
  reuseLast: boolean;
  fromHistoryUid: ?string;
  fromNavigate: boolean;
  currentModule: ?Object;
  extraData: any;

  constructor() {
    /**
     * @type {DenzelEvent}
     */
    this.evt = null;

    /**
     * True if the main module handled the navigate already.
     * @type {boolean}
     */
    this.handled = false;

    /**
     * If true, re-use the last module.
     * @type {boolean}
     */
    this.reuseLast = false;

    /**
     * The url that should reuse the last module.
     * This is only used if #reuseLast is true.
     * @type {?string}
     */
    this.fromHistoryUid = null;

    /**
     * Whether the route was from a navigate action.
     * @type {boolean}
     */
    this.fromNavigate = false;

    /**
     * @type {Module}
     */
    this.currentModule = null;
  }
}

export default NavigateData;
